import { render, staticRenderFns } from "./Last-db-sync.vue?vue&type=template&id=2305b4a2&"
import script from "./Last-db-sync.vue?vue&type=script&lang=js&"
export * from "./Last-db-sync.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports